<template>
  <tr
    v-if="project"
    :class="{ deleted: isDeleted }"
    :style="{ 'background-color': highlightColor }"
    :title="label"
    @dblclick="$router.push({ name: 'projectsDetail', params: { id: project.id } })"
  >
    <td class="asd-btn-group">
      <router-link :to="{ name: 'projectsDetail', params: { id: project.id } }">
        <button v-help.mouse="`Editovat projekt`"
                type="button"
                class="asd-btn-edit asd-btn-single-icon"
        >
          <i class="fas fa-pencil-alt"></i>
        </button>
      </router-link>
    </td>
    <td @click="highlightRow">
      <span v-if="isTemplate"
            v-help.mouse="`Toto je šablona projektu`"
      >
        <i class="fab fa-firstdraft"></i>
      </span>
      {{ projectType.name }}
    </td>
    <td v-for="(prop, key) in propertiesToShow"
        :key="key"
        :class="{ 'empty-value': !prop }"
        @click="highlightRow"
    >
      <template v-if="prop">
        <PropertyDetailProxy
          :id="key"
          :key="key"
          :value="prop"
          :color="color"
          :meta="{ projectId }"
        ></PropertyDetailProxy>
      </template>
      <template v-else>
      </template>
    </td>
    <td class="indicator-td">
      <span v-if="projectComments.length"
            class="comment-indicator"
      >
        <i class="far fa-comment fa-2x"></i>
        <span class="badge badge-danger count-badge">{{ projectComments.length }}</span>
      </span>
    </td>
    <td class="indicator-td">
      <span v-if="projectAttachments.length"
            class="attachment-indicator"
      >
        <i class="fas fa-paperclip fa-2x"></i>
        <span class="badge badge-danger count-badge">{{ projectAttachments.length }}</span>
      </span>
    </td>
    <div
      class="modal fade bd-example-modal-sm show"
      tabindex="-1"
      role="dialog"
      :style="{ display: showModal ? 'block' : 'none' }"
    >
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <h4 v-if="isTemplate"
                id="mySmallModalLabel"
                class="modal-title"
            >
              Smazat šablonu?
            </h4>
            <h4 id="mySmallModalLabel"
                class="modal-title"
            >
              Smazat projekt?
            </h4>
          </div>
          <div class="modal-body modal-footer">
            <button type="button"
                    class="btn btn-primary"
                    @click="showModal = false"
            >
              Storno
            </button>
            <button type="button"
                    class="btn btn-danger"
                    @click="disableProject()"
            >
              Smazat
            </button>
          </div>
        </div>
      </div>
    </div>
  </tr>
</template>

<script>
import LangFilters from 'CORE/mixins/langFilters'
import ProjectDataMixin from 'CORE/mixins/project-data'
import RowHighlightMixin from 'CORE/mixins/row-highlight'
import PropertyDetailProxy from 'CORE/components/data-type/property-detail-proxy'
import { get, set } from 'lodash'
import labels from 'CORE/utils/labels'

export default {
    name: 'ProjectRow',
    components: {
        PropertyDetailProxy,
    },
    mixins: [LangFilters, ProjectDataMixin, RowHighlightMixin],
    props: {
        projectId: {
            type: String,
            required: true,
        },
        propsToShow: {
            type: Array,
            required: false,
            default: _ => ['system-name', 'system-creator'],
        },
    },
    data() {
        return {
            showModal: false,
        }
    },
    computed: {
        propertiesToShow() {
            const pts = {}
            for (const p of this.propsToShow) {
                set(pts, p, get(this, `project.propertyValues.${p}`))
            }
            return pts
        },
        color() {
            return get(this.project, 'propertyValues.system-color.value', 'default')
        },
        isDeleted() {
            return !!get(this.project, 'validUntil', false)
        },
        isTemplate() {
            return !!get(this.project, 'isTemplate', false)
        },
        label() {
            return labels.project(this.project)
        },
    },
    methods: {
        async disableProject() {
            try {
                await this.$store.dispatch('disableProject', this.project.id)
                await this.$store.dispatch('projectsLoad')
                this.flash('Projekt byl označen k smazání. Avšak zůstane ještě 7 dní v archivu.', 'success', {
                    timeout: 5000,
                })
            } catch (e) {
                this.flash(`Chyba ${e}`, 'danger')
            } finally {
                this.showModal = false
            }
        },
    },
}
</script>
